export class Server {
    Id: number;
    Name: string;
    HostName: string;
}

export class Fleet {
    Id: number;
    ServerId: number;
    DisplayName: string;
}


export class ServerVehicle {
    Id: number;
    ServerId: number;
    FleetId: number;
    DisplayName: string;
    Registration: string;
    SerialNumber: string;
    Make: string;
    Model: string;
    Vin: string;
}

export class ServerDriver {
    Id: number;
    ServerId: number;
    FleetId: number;
    DisplayName: string;
    LastName: string;
    FistName: string;
}

